module.exports = __webpack_public_path__ + "media/featured_internships/un-logo-8d5c1869.jpg";